var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BenefitCardList",
      "extra-items": _vm.isEditing ? [{
        text: _vm.benefitCard.title
      }, '編輯權益卡'] : ['新增權益卡']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-2 mail-sidebar pt-3"
  }, [_c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_c('li', {
    class: {
      active: _vm.step == ''
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('');
      }
    }
  }, [_c('a', [_vm._v("基本設定")])]), _c('li', {
    class: {
      active: _vm.step == '#customer-level',
      disabled: !_vm.benefitCard.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#customer-level');
      }
    }
  }, [_c('a', [_vm._v("會員等級設定")])]), _c('li', {
    class: {
      active: _vm.step == '#benefit',
      disabled: !_vm.benefitCard.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#benefit');
      }
    }
  }, [_c('a', [_vm._v("權益設定")])]), _c('li', {
    class: {
      active: _vm.step == '#content',
      disabled: !_vm.benefitCard.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#content');
      }
    }
  }, [_c('a', [_vm._v("內容設定")])])])])]), _c('div', {
    staticClass: "col-md-10 main-view"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_vm.step == '' ? _c('section', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-3 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.isEditing ? '編輯權益卡' : '新增權益卡'))]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*名稱欄位"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.benefitCard.title.$error ? false : null
    },
    model: {
      value: _vm.benefitCard.title,
      callback: function callback($$v) {
        _vm.$set(_vm.benefitCard, "title", $$v);
      },
      expression: "benefitCard.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.benefitCard.title.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否開放"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": 1,
      "unchecked-value": 0
    },
    model: {
      value: _vm.benefitCard.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.benefitCard, "is_enabled", $$v);
      },
      expression: "benefitCard.is_enabled"
    }
  }, [_vm._v("開放")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開始時間"
    }
  }, [[_c('AppDatePicker', {
    attrs: {
      "placeholder": "開始時間"
    },
    model: {
      value: _vm.benefitCard.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.benefitCard, "start_at", $$v);
      },
      expression: "benefitCard.start_at"
    }
  })]], 2), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束時間"
    }
  }, [[_c('AppDatePicker', {
    attrs: {
      "placeholder": "結束時間"
    },
    model: {
      value: _vm.benefitCard.end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.benefitCard, "end_at", $$v);
      },
      expression: "benefitCard.end_at"
    }
  })]], 2), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*順序"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.benefitCard.order.$error ? false : null
    },
    model: {
      value: _vm.benefitCard.order,
      callback: function callback($$v) {
        _vm.$set(_vm.benefitCard, "order", $$v);
      },
      expression: "benefitCard.order"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.benefitCard.order.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" 卡片主圖 "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 630px")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('AppFileUploader', {
          attrs: {
            "placeholder-when-uploaded": "（查看檔案）",
            "placeholder-when-empty": ""
          },
          model: {
            value: _vm.benefitCard.config.page_image,
            callback: function callback($$v) {
              _vm.$set(_vm.benefitCard.config, "page_image", $$v);
            },
            expression: "benefitCard.config.page_image"
          }
        })];
      },
      proxy: true
    }], null, false, 1820326023)
  })], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)]) : _vm._e(), _vm.step == '#customer-level' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '權益卡名稱',
      "name": _vm.benefitCard.title
    }
  }), _c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v("會員等級設定")])]), _c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-search-customer-level",
      modifiers: {
        "modal-search-customer-level": true
      }
    }],
    staticClass: "flex-shrink-0 mr-2",
    attrs: {
      "variant": "inverse-primary",
      "disabled": _vm.showLoading
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("選擇會員等級")])], 1), _c('b-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectedCustomerLevels.length > 0,
      expression: "selectedCustomerLevels.length > 0"
    }],
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.selectedCustomerLevels,
      "fields": _vm.customerLevelFields
    },
    scopedSlots: _vm._u([{
      key: "cell(title)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerLevelsEdit',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('div', [_vm._v(_vm._s(_vm.deepGet(data.item, 'name')))])])];
      }
    }, {
      key: "cell(description)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(_vm._s(_vm.deepGet(data.item, 'description')))])];
      }
    }, {
      key: "cell(created_at)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(_vm._s(_vm.formatDate(_vm.deepGet(data.item, 'created_at'))))])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-info"
          }
        }, [_c('span', {
          staticClass: "mdi mdi-settings"
        }), _vm._v(" 設定 ")]), _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteCustomerLevel(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 移除 ")])];
      }
    }], null, false, 2359561093)
  }), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1) : _vm._e(), _c('CustomerLevel', {
    attrs: {
      "selectedCustomerLevels": _vm.selectedCustomerLevels
    },
    on: {
      "submit": _vm.handleSubmitCustomerLevel
    }
  }), _vm.step == '#benefit' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '權益卡名稱',
      "name": _vm.benefitCard.title
    }
  }), _c('div', {
    staticClass: "row d-flex mb-12 mb-xl-12"
  }, [_c('div', {
    staticClass: "col-12 col-xl-12 mb-12 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" 權益設定 ")]), _vm.isBenefitSetting ? _c('div', {
    staticClass: "ml-2",
    domProps: {
      "textContent": _vm._s(_vm.benefitSettingText)
    }
  }, [_vm._v(" / 新增權益 ")]) : _vm._e()])]), !_vm.isBenefitSetting ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_c('b-button', {
    staticClass: "flex-shrink-0 mr-2",
    attrs: {
      "variant": "inverse-primary",
      "disabled": _vm.showLoading
    },
    on: {
      "click": function click($event) {
        return _vm.selectBenefitSetting(_vm.standardBenefitSetting);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增權益")])], 1) : _vm._e(), _c('BenefitSetting', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isBenefitSetting,
      expression: "isBenefitSetting"
    }],
    ref: "benefitSetting",
    attrs: {
      "selectedCoupon": _vm.selectedCoupon,
      "selectedBenefitSetting": _vm.selectedBenefitSetting
    },
    on: {
      "close": _vm.closeBenefitSetting,
      "submit": _vm.handleSubmitBenefitSetting
    }
  }), _c('b-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.benefitSettings.length > 0 && !_vm.isBenefitSetting,
      expression: "benefitSettings.length > 0 && !isBenefitSetting"
    }],
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.sortedBenefitSettings,
      "fields": _vm.benefitSettingFields
    },
    scopedSlots: _vm._u([{
      key: "cell(title)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'RedeemCodeBundleEdit',
              params: {
                redeemCodeBundleId: data.item.id
              }
            }
          }
        }, [_c('div', [_vm._v(_vm._s(_vm.deepGet(data.item, 'name')))])])];
      }
    }, {
      key: "cell(tab_image)",
      fn: function fn(data) {
        return [_vm.deepGet(data.item, 'tab_image') ? _c('b-img-lazy', {
          staticClass: "thumb-image",
          staticStyle: {
            "width": "auto"
          },
          attrs: {
            "src": _vm.deepGet(data.item, 'tab_image'),
            "alt": "圖片",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(coupon.img_url)",
      fn: function fn(data) {
        return [_vm.deepGet(data.item, 'coupon.img_url') ? _c('b-img-lazy', {
          staticClass: "thumb-image",
          attrs: {
            "src": _vm.deepGet(data.item, 'coupon.img_url'),
            "alt": "圖片",
            "width": "50",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(updated_at)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(_vm._s(_vm.formatDate(_vm.deepGet(data.item, 'updated_at'))))])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-info"
          },
          on: {
            "click": function click($event) {
              return _vm.selectBenefitSetting(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-settings"
        }), _vm._v(" 編輯 ")]), _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteBenefitSetting(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 移除 ")])];
      }
    }], null, false, 3146598859)
  })], 1) : _vm._e(), _vm.step == '#content' ? _c('section', [_c('NameBlock', {
    attrs: {
      "label": '權益卡名稱',
      "name": _vm.benefitCard.title
    }
  }), _c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-12 mb-3 font-weight-bold"
  }, [_vm._v("內容設定")]), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "內容設定"
    }
  }, [_c('JsonEditor', {
    ref: "statusFilterMapping",
    attrs: {
      "height": "128px"
    },
    model: {
      value: _vm.benefitCard.config,
      callback: function callback($$v) {
        _vm.$set(_vm.benefitCard, "config", $$v);
      },
      expression: "benefitCard.config"
    }
  }), _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.presentValidationErrors('benefitCard.config')) + " ")])], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1) : _vm._e()], 1)], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }